import { render, staticRenderFns } from "./PixPagamento.vue?vue&type=template&id=fc1a7f0a&scoped=true"
import script from "./PixPagamento.vue?vue&type=script&lang=js"
export * from "./PixPagamento.vue?vue&type=script&lang=js"
import style0 from "./PixPagamento.vue?vue&type=style&index=0&id=fc1a7f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1a7f0a",
  null
  
)

export default component.exports